var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content item-create" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [
        _vm._v(
          _vm._s(
            _vm.isEdit
              ? _vm.$t("communications.edit_communication")
              : _vm.$t("communications.new_communication")
          )
        ),
      ]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c(
          "li",
          { staticClass: "breadcrumb-item" },
          [
            _c(
              "router-link",
              {
                attrs: { slot: "item-title", to: "/super-admin/dashboard" },
                slot: "item-title",
              },
              [_vm._v(_vm._s(_vm.$t("general.home")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "breadcrumb-item" },
          [
            _c(
              "router-link",
              {
                attrs: {
                  slot: "item-title",
                  to: "/super-admin/communications",
                },
                slot: "item-title",
              },
              [_vm._v(_vm._s(_vm.$tc("communications.communication", 2)))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("li", { staticClass: "breadcrumb-item" }, [
          _c("a", { attrs: { href: "#" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.isEdit
                    ? _vm.$t("communications.edit_communication")
                    : _vm.$t("communications.new_communication")
                )
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("div", { staticClass: "card" }, [
          _c(
            "form",
            {
              attrs: { action: "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submitCommunication($event)
                },
              },
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [
                          _vm._v(
                            _vm._s(_vm.$tc("communications.action_type", 2))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("base-select", {
                          attrs: {
                            options: _vm.action_types,
                            searchable: true,
                            "show-labels": false,
                            placeholder: _vm.$t(
                              "communications.select_a_action_type"
                            ),
                            label: "name",
                            "track-by": "id",
                          },
                          model: {
                            value: _vm.formData.action_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "action_type", $$v)
                            },
                            expression: "formData.action_type",
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.formData.action_type.$error
                          ? _c("div", [
                              !_vm.$v.formData.action_type.required
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$tc("validation.type_required")
                                        ) +
                                        "\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("communications.subject"))),
                        ]),
                        _vm._v(" "),
                        _c("base-input", {
                          attrs: {
                            placeholder: _vm.$t("communications.subject"),
                            label: "name",
                          },
                          model: {
                            value: _vm.formData.subject,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "subject", $$v)
                            },
                            expression: "formData.subject",
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.formData.subject.$error
                          ? _c("div", [
                              !_vm.$v.formData.subject.required
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$tc("validation.subject_required")
                                        ) +
                                        "\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-12" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "message" } }, [
                          _vm._v(_vm._s(_vm.$t("communications.message"))),
                        ]),
                        _vm._v(" "),
                        _c("base-text-area", {
                          attrs: { rows: "4", name: "message" },
                          on: {
                            input: function ($event) {
                              return _vm.$v.formData.message.$touch()
                            },
                          },
                          model: {
                            value: _vm.formData.message,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "message", $$v)
                            },
                            expression: "formData.message",
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.formData.message.$error
                          ? _c("div", [
                              !_vm.$v.formData.message.maxLength
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$t(
                                            "validation.description_maxlength"
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "base-button",
                            {
                              staticClass: "collapse-button m-auto",
                              attrs: {
                                loading: _vm.isLoading,
                                disabled: _vm.isSubmitDisabled,
                                icon: "save",
                                color: "theme",
                                type: "submit",
                              },
                            },
                            [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm.isEdit
                                      ? _vm.$t(
                                          "communications.update_communication"
                                        )
                                      : _vm.$t(
                                          "communications.save_communication"
                                        )
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }